import Chance from 'chance';

import { SuggestionHighlight as suggestionHighlight } from '../../ontologySuggestions';

const chance = new Chance();

const licencesCertificationsSpecReqs = [
  'AHPRA Registration',
  'Bartending',
  'Chartered Accountancy',
  'Drivers Licence',
  'Front of House',
  'Certificate III in Printing Machining',
  'Heavy Rigid Vehicle',
  'Information Communication Technology',
  'iOS Development',
  'Jazz Music',
  'Languages Other Than English',
  'Management Information System',
  'Natural Language Programming',
  'Point of Sale Software',
  'Television Production',
  'Vb.Net',
  'Zendesk',
];

const skillsSpecReqs = [
  'Microsoft PowerPoint',
  'Microsoft Excel',
  'Time Management',
  'Front of House',
  'HTML5',
  'AWS Cloudformation',
  'Supply Chain Management',
  'SEO',
  'Ruby on Rails',
  'Quality Assurance Testing',
  'Breadmaking',
  'Linux',
  'Learning and Development',
  'Lecturing',
];

const languageProficiencySpecReqs = [
  'French',
  'Spanish',
  'Italian',
  'Hebrew',
  'Chinese - Cantonese',
  'Hungarian',
  'Portuguese',
  'Filipino',
  'Thai',
  'Greek',
  'German',
  'Chinese - Mandarin',
  'Swedish',
  'English',
  'Hindi',
];

const specreqs = {
  LicencesCertifications: licencesCertificationsSpecReqs,
  Skills: skillsSpecReqs,
  LanguageProficiency: languageProficiencySpecReqs,
};

const defaultSpecreq = ['Mock suggestion'];

// eslint-disable-next-line import-x/no-default-export
export default (_: any, { profileField }: Record<string, string>) => {
  const specreq =
    profileField in specreqs
      ? specreqs[profileField as keyof typeof specreqs]
      : defaultSpecreq;

  const chosenSpecreqs = chance.pickset(specreq, 10);

  return chosenSpecreqs.map((suggestion) => ({
    id: `https://graph.cloud.seek.com/Spec-Req/${chance.guid()}`,
    matchedVariant: suggestion,
    normalisedText: suggestion,
    highlights: () => (chance.bool() ? [suggestionHighlight()] : []),
    collectExpiry: chance.bool(),
  }));
};
